import * as React from "react";
import Box from "@mui/material/Box";
import Avatar from "./Avatar";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useState } from "react";
import TextField from "@mui/material/TextField";

export default function EditProfileInput(props) {
  const submitHandler = (event) => {
    event.preventDefault();
    console.log("Submitted!");
  };
  return (
    <Box sx={{ minWidth: 275 }}>
      <Card variant="outlined" sx={{ minWidth: 275 }}>
        <CardContent>
          <Avatar details={props.details} />
          <Box
            component="form"
            sx={{
              "& .MuiTextField-root": { m: 1, width: "25ch" },
            }}
            noValidate
            autoComplete="off"
            onSubmit={submitHandler}
          >
            <TextField required id="outlined-required" label="Name" />
            <TextField required id="outlined-required" label="Username" />
            <TextField
              id="outlined-multiline-static"
              label="Multiline"
              multiline
              rows={4}
              defaultValue="Bio"
            />
            <TextField required id="outlined-required" label="Course" />
            <TextField required id="outlined-required" label="Cohort" />
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
